__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "hostApp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common/http", "21.2.15", () => (__webpack_require__.e(613).then(() => (() => (__webpack_require__(16613))))));
			register("@angular/common", "21.2.15", () => (__webpack_require__.e(352).then(() => (() => (__webpack_require__(21352))))));
			register("@angular/core/primitives/di", "21.2.15", () => (__webpack_require__.e(894).then(() => (() => (__webpack_require__(8513))))));
			register("@angular/core/primitives/signals", "21.2.15", () => (__webpack_require__.e(699).then(() => (() => (__webpack_require__(36699))))));
			register("@angular/core/rxjs-interop", "21.2.15", () => (__webpack_require__.e(74).then(() => (() => (__webpack_require__(49074))))));
			register("@angular/core", "21.2.15", () => (__webpack_require__.e(460).then(() => (() => (__webpack_require__(49460))))));
			register("@angular/router", "21.2.15", () => (__webpack_require__.e(126).then(() => (() => (__webpack_require__(38745))))));
			register("lottie-web", "5.13.0", () => (__webpack_require__.e(335).then(() => (() => (__webpack_require__(24335))))));
			register("ngx-lottie", "11.0.2", () => (__webpack_require__.e(706).then(() => (() => (__webpack_require__(37325))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};